import { observable } from 'mobx';
import copyright from '../static/statement/statement.png';

class CopyrightMobx {
  @observable copyrightImg = copyright;
}

export default CopyrightMobx;